import { cashCents } from "./receiptCashChoice";
import type { CrossBranchItem } from "@/hooks/use-cross-branch-cash";

export function payerAmountAllowed(amount: string, balance: string) {
  const a = cashCents(amount), b = cashCents(balance);
  return a !== null && b !== null && a > 0 && a <= b;
}
/** The endpoint supplies signed expenditure, including reversal rows. Never
 * discard reversed originals: doing so would subtract their reversal twice. */
export function crossBranchPeriodTotal(items: CrossBranchItem[], paidFrom?: string[]) {
  const cents = items.filter(i => i.forBranchId !== i.paidFromBranchId && (!paidFrom || paidFrom.includes(i.paidFromBranchId)))
    .reduce((sum, i) => {
      if (i.signedAmount == null) return sum;
      const negative = i.signedAmount.startsWith("-");
      const value = cashCents(i.signedAmount.replace(/^-/, ""));
      return sum + (value ?? 0) * (negative ? -1 : 1);
    }, 0);
  return (cents / 100).toFixed(2);
}